import { PaymentTypes } from '@core-http';

export const paymentTypesMapper: Record<PaymentTypes, string> = {
  [PaymentTypes.CASH]: 'Gotówka',
  [PaymentTypes.BLIK]: 'BLIK',
  [PaymentTypes.TRANSFER]: 'Przelew'
};

export const reversedPaymentTypesMapper: Record<string, PaymentTypes> = Object.entries(paymentTypesMapper).reduce(
  (acc, [key, value]) => {
    acc[value] = PaymentTypes[key as keyof typeof PaymentTypes];
    return acc;
  },
  {} as Record<string, PaymentTypes>
);
